export const menuIs = {
  hero: {
    title: 'Matseðillinn okkar',
    subtitle: 'Ekta napólsk matargerð gerð með ást og hefð',
  },
  allergyNote: 'Vinsamlegast látið þjóninn vita ef þú ert með ofnæmi eða óþol.',
  bookTable: 'Bóka borð',
  legend: {
    vegetarian: 'Grænmetisréttur',
    spicy: 'Sterkur',
    special: 'Sérréttur',
    recommended: 'Mælt með',
  },
  categories: {
    antipasti: 'Forréttir',
    zuppe: 'Súpur',
    risotto: 'Risotto',
    insalate: 'Salöt',
    bambini: 'Fyrir 12 ára og yngri',
    pasta: 'Pasta',
    pesce: 'Fiskur',
    carne: 'Kjöt',
    pizze: 'Pizza',
    desserts: 'Eftirréttir',
  },
  items: {
    1: {
      name: 'Bruschetta Pomodoro e aglietto',
      description: 'Heimabakað brauð með tómötum, hvítlauk, basiliku, origano og ólífuolíu.',
    },
    2: {
      name: 'Bruschetta Salmone',
      description: 'Heimabakað brauð með salati, reyktum lax og dressingu.',
    },
    3: {
      name: 'Bruschetta Caprese',
      description: 'Heimabakað brauð með tómötum, ferskum mozzarella og basiliku.',
    },
    4: {
      name: 'Bruschetta Mix fyrir 2',
      description: 'Fyrir 2 til að deila - blandað bruschetta',
    },
    5: {
      name: 'Bruschetta Mix fyrir 4',
      description: 'Fyrir 4 til að deila - blandað bruschetta',
    },
    6: {
      name: 'Pane All´Aglio',
      description: 'Eldbakað hvítlauksbrauð með osti',
    },
    7: {
      name: 'Calamari Fritti',
      description: 'Djúpsteiktur smokkfiskur með sítrónu og hvítlauksmajonesi.',
    },
    8: {
      name: 'Carpaccio',
      description:
        'Þunnt sneitt nautakjöt með ólífuolíu, sítrónu, klettasalati og sneiddum parmesan.',
    },
    9: {
      name: 'Gamberoni alla "Zio Pepper"',
      description: 'Pönnusteikt risarækja með sterkum hvítlauk og smjörsósu.',
    },
    10: {
      name: 'Zuppa del giorno',
      description: 'Súpa dagsins (nánari upplýsingar hjá næsta þjóni)',
    },
    11: {
      name: 'Zuppa di frutti di mare',
      description: 'Rjómalöguð sjávarréttasúpa með krækling, rækjum og hörpuskel.',
    },
    12: {
      name: 'Risotto ai Funghi',
      description: 'Risotto með villisveppum, kjúkling og timian',
    },
    13: {
      name: 'Risotto del Pescatore',
      description: 'Risotto með sjávarréttum og saffran keim',
    },
    14: {
      name: 'Rocket salat',
      description:
        'Klettasalat, gulir og rauðir Datterino tómatar, parmesan ostur ólífuolía og balsamik.',
    },
    15: {
      name: 'Caprese',
      description: 'Ferskur mozzarella, tómatar, oregano, basilika og olífuolía',
    },
    16: {
      name: 'RossoPomodoro',
      description:
        'Blandað salat og klettasalat með hráskinku, tómötum, eggi, ólífum og parmesan osti',
    },
    17: {
      name: 'Insalata alla cesare',
      description: 'Cesar salat með grilluðum kjúkling, brauðteningum, beikon og parmesan osti',
    },
    18: {
      name: 'Insalata mista',
      description: 'Hliðar salat (grænt salat og tómatar)',
    },
    19: {
      name: 'Lasagne',
      description: 'Lasagne með kjötsósu',
    },
    20: {
      name: 'Spaghetti Bolognese',
      description: 'Spaghetti með kjötsósu',
    },
    21: {
      name: 'Penne pasta',
      description: 'Penne pasta í tómatsósu',
    },
    22: {
      name: 'Kjúklingabringa',
      description: 'Kjúklingabringa með frönskum',
    },
    23: {
      name: 'Pizza Margherita',
      description: 'Pizza með sósu og mozzarella',
    },
    24: {
      name: 'Pizza með skinku',
      description: 'Pizza með sósu, mozzarella og skinku',
    },
    25: {
      name: 'Pizza með súkkulaði',
      description: 'Pizza með Nutella',
    },
    26: {
      name: 'Penne con Pancetta e Pollo',
      description: 'Penne pasta með kjúkling og beikon í rósmarín tómatsósu.',
    },
    27: {
      name: 'Penne all´Arrabiata',
      description: 'Penne pasta með chilli og tómatsósu',
    },
    28: {
      name: 'Penne Prosciutto e Panna',
      description: 'Penne pasta með skinku, sveppum í rjómaostasósu.',
    },
    29: {
      name: 'Lasagne di Carne',
      description: 'Lasagna með Bolognese- og Bechamel sósu',
    },
    30: {
      name: 'Spaghetti alla Carbonara',
      description: 'Spaghetti Carbonara með beikon, rjóma, eggi og svörtum pipar.',
    },
    31: {
      name: 'Spaghetti Aglio Olio e Pomodorini',
      description: 'Spaghetti með hvítlauk, olífuolíu, chilli, steinselju og cherry tómötum.',
    },
    32: {
      name: 'Spaghetti Bolognese',
      description: 'Spaghetti bolognese lagað af fyrsta flokks nautahakki',
    },
    33: {
      name: 'Cannelloni con Spinaci e Ricotta',
      description: 'Canneloni fyllt með ricotta-osti og spínati.',
    },
    34: {
      name: 'Ravioli ai Funghi',
      description: 'Ravioli fyllt með ricotta og spínati í rjómasveppasósu.',
    },
    35: {
      name: 'Linguine ai Gamberoni',
      description: 'Linguini með risarækjum í rjóma- og chili sósu.',
    },
    36: {
      name: 'Linguine allo Scoglio',
      description:
        'Linguine með smokkfiski, krækling, hörpuskelfisk og risarækjum í hvítvíns-tómatsósu.',
    },
    37: {
      name: 'Spaghetti con Polpette',
      description: 'Spaghetti með kjötbollum.',
    },
    38: {
      name: 'Fiskur dagsins',
      description: 'Fiskur dagsins (upplýsingar hjá næsta þjón)',
    },
    39: {
      name: 'Salmone al forno con aneto e Pernod',
      description: 'Ofnbakaður Lax með dill-pernod sósu, kartöflum og grænmeti.',
    },
    40: {
      name: 'Milanese di Maiele',
      description: 'Svínasnitsel með rjóma-villisveppa sósu, grænmeti og kartöflum',
    },
    41: {
      name: 'Petto di Pollo',
      description:
        'Grilluð kjúklingabringa fyllt með parmaskinku, ferskum mozzarella osti með rauðvínssósu og kartöflum.',
    },
    42: {
      name: 'Agnello al Rosmariono',
      description: 'Grillað lambafillet með grænmeti, bakaðri kartöflu og rjómasveppasósu',
    },
    43: {
      name: 'Filetto di Manzo al Pepe',
      description: 'Grilluð nautalund með bakaðri kartöflu og rjómapiparssósu',
    },
    44: {
      name: 'Filetto di manzo al funghi',
      description: 'Grilluð nautalund með bakaðri kartöflu og rjómasveppasósu',
    },
    45: {
      name: 'Margherita',
      description: 'Sósa, mozzarella og basilíka.',
    },
    46: {
      name: 'Napoli',
      description: 'Sósa, ansjósur, hvítlaukur, oregano, ostur og ólífur',
    },
    47: {
      name: 'Ventura',
      description: 'Mozzarella, hráskinka, klettasalat og rifinn parmesan',
    },
    48: {
      name: 'Rustica',
      description: 'Sósa, mozzarella, skinka og sveppir',
    },
    49: {
      name: 'Tonno e Cipolla',
      description: 'Sósa, mozzarella, túnfiskur og laukur',
    },
    50: {
      name: 'Sorrentina',
      description: 'Sósa, mozzarella og pepperoni',
    },
    51: {
      name: 'Formaggi',
      description: 'Mozzarella-, ricotta-, bufala-, camembert- og gorgonzola ostur',
    },
    52: {
      name: 'Calzone',
      description: 'Hálfmáni með sósu, mozzarella, skinku og sveppum',
    },
    53: {
      name: 'Capricciosa',
      description: 'Sósa, mozzarella, skinka, sveppir, ólífur og þistilhjörtu.',
    },
    54: {
      name: 'Corbarella',
      description: 'Mozzarella, rjómi, skinka, sveppir og svartur pipar.',
    },
    55: {
      name: 'Vegeteriana',
      description: 'Sósa, mozzarella og grillað grænmeti og sveppir.',
    },
    56: {
      name: 'Verace',
      description: 'Sósa, ferskur mozzarella og basilíka.',
    },
    57: {
      name: 'Marinarella',
      description:
        'Sósa, mozzarella, hvítlaukur, kræklingur, smokkfiskur, risarækjur og hörpuskel.',
    },
    58: {
      name: 'Hawaian',
      description: 'Sósa, mozzarella, skinka og ananas',
    },
    59: {
      name: 'Verona',
      description: 'Sósa, mozzarella, pepperoni, laukur og rjóma ostur',
    },
    60: {
      name: 'Pizzaiolo',
      description: 'Mozzarella, pepperoni, jalapeño, ólífur, hakk og hvítlauk',
    },
    61: {
      name: 'Pizza del Piazzaiolo',
      description: 'Ferskur mozzarella, skinka, pepperoni, piparostur og beikon.',
    },
    62: {
      name: 'Salmone',
      description: 'Mozzarella, rjómaostur, klettasalat og reyktur lax.',
    },
    63: {
      name: 'Tíramisú',
      description: 'Hefðbundinn ítalskur eftirréttur.',
    },
    64: {
      name: 'Nero Mangiare',
      description: 'Volg súkkulaðikaka með vanilluís.',
    },
    65: {
      name: "'O Gelato",
      description: 'Ítalskur ís.',
    },
    66: {
      name: 'Brulée',
      description: 'Vanillu brulée.',
    },
    67: {
      name: "'A Torta",
      description: 'Heit eplakaka með vanillu ís og rjóma.',
    },
  },
};
